module.exports = __webpack_public_path__ + "static/media/Icon material-skip-next.687b63e3.svg";